@import "~@uipath/apollo-core/src/scss/base-host.scss";
@import "~@uipath/apollo-core/src/scss/_variables.scss";
@import url("https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined");

.dialog {
    display: flex;
    flex-direction: row;
}

.dialog-close-button {
    cursor: pointer;
}

.dialog-close {
    align-self: flex-start;
    margin: 20px 20px 0px 0px;
    width: 20px;
}

.dialog-content {
    width: inherit;
}
